angular
  .module('workflow')

  .factory('WorkflowCancelBilledInvoiceCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class WorkflowCancelBilledInvoiceCrud extends Crud {
        constructor() {
          super(null, '@@apiUrl' + '/workflow-cancel-billed-invoice' + '/:id', {
            id: '@id'
          });
        }
      }
      return WorkflowCancelBilledInvoiceCrud;
    }
  ]);
